import { Node } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";

import ProseMirrorImageBlock from "@/view/ProseMirrorNode/ProseMirrorImageBlock";
import { useDynamicDataProvider } from "@/view/TiptapArticleBody/extensions/DataProvider";
import { ComponentProps } from "@/view/TiptapArticleBody/TiptapArticleBody.interface";
import useTranslatorControlsContext from "@/view/utils/useTranslatorControlsContext";
import {
  imageWrapperStyles,
  imageWrapperWithTranslateStyles,
} from "./Image.style";

const Component = (props: ComponentProps) => {
  const { node, editor } = props;
  const { media, currentFontSize, levelId } = useDynamicDataProvider(editor);

  const { isTranslateMode } = useTranslatorControlsContext();

  const shouldShowTranslateButton = isTranslateMode;

  return (
    <NodeViewWrapper
      css={
        shouldShowTranslateButton
          ? imageWrapperWithTranslateStyles
          : imageWrapperStyles
      }
    >
      {media ? (
        <ProseMirrorImageBlock
          additionalData={media}
          currentFontSize={currentFontSize}
          levelId={levelId}
          node={node}
        />
      ) : (
        <></>
      )}
    </NodeViewWrapper>
  );
};

export const Image = Node.create({
  name: "image_block",
  content: "text*",
  group: "inline",
  inline: true,
  renderHTML() {
    return ["image", 0];
  },
  addAttributes() {
    return {
      bestCaption: "",
      contentId: null,
      isFullWidth: false,
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});
